module.exports = __webpack_public_path__ + "img/Differentiation-OSCC_GSE208253.7e16e235.png";